import React from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'
import { keyframes } from '@emotion/core'

const spinAnimation = keyframes`
  0% {
    stroke-dashoffset: 375;
    transform: rotate(-90deg) scale(0.9);
  }
  80% {
    opacity: 1;
    stroke-dashoffset: 25;
    transform: rotate(-90deg) scale(1);
  }
  100% {
    opacity: 0;
  }
`

const checkAnimation = keyframes`
  to {
    stroke-dashoffset: 0;
  }
`

const StyledSvg = styled('svg')`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;

  @media only screen and (max-width: 767px) {
    width: ${({ size }) => size * 0.8}px;
    height: ${({ size }) => size * 0.8}px;
  }

  circle {
    fill: transparent;
    stroke: ${({ theme }) => theme.text.white };
    stroke-width: var(--icon-stroke-width, 2);
    stroke-linecap: round;
    stroke-dasharray: 400;
    transform-origin: 50% 50%;
    transform-box: fill-box;
    animation: ${spinAnimation} 1s linear infinite;
  }

  polyline {
    fill: transparent;
    stroke: ${({ theme }) => theme.text.white };
    stroke-width: var(--icon-stroke-width, 2);
    stroke-dasharray: 100;
    stroke-dashoffset: 100;
    stroke-miterlimit: 10;
    stroke-linejoin: round;
    stroke-linecap: round;
  }

  &.complete {
    circle {
      animation: ${checkAnimation} 1s linear forwards;
      animation-iteration-count: 1;
      stroke: ${({ theme }) => theme.success.base};
    }

    polyline {
      animation: ${checkAnimation} 1s linear forwards;
      stroke: ${({ theme }) => theme.success.base};
    }
  }
`

const SuccessSpinner = ({ complete, ...rest }) => (
  <StyledSvg
    className={complete && 'complete'}
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 100 100'
    preserveAspectRatio='xMidYMid meet'
    {...rest}
  >
    <circle cx={50} cy={50} r={50 - 2} />
    <polyline points='34.8,52.2 46.5,62.9 65,35.7 ' />
  </StyledSvg>
)

SuccessSpinner.propTypes = {
  complete: PropTypes.bool,
  size: PropTypes.number,
}

SuccessSpinner.defaultProps = {
  size: 100,
}

export default SuccessSpinner
